import { Comment, Avatar, Tag, Popconfirm, Form, Input } from "antd";

import moment from "moment";
import Button from "antd-button-color";

import "./style.css";

const REPLY = "REPLY";
const MESSAGE = "MESSAGE";

const CommentContainer = ({ username, isAdmin, content, image, body, children }) => {
  const author = (
    <>
      <b>{username}</b>
      <Tag className="me-1 mb-0 m-l-5 label-tag-comment" visible={isAdmin}>
        Admin
      </Tag>{" "}
      &bull; {moment(new Date()).startOf("minute").fromNow()}
      <span className="hover-pointer action-btn">
        <Popconfirm
          title="Hapus komentar?"
          okText="Ya"
          cancelText="Batal"
          placement="bottomRight"
          arrowPointAtCenter
          // onConfirm={() => onDeleteCommentOrReply()}
        >
          <i className="fal fa-ellipsis-h-alt" />
        </Popconfirm>
      </span>
    </>
  );

  const contentMessage = <p>{content}</p>;

  const contentReply = (
    <Form>
      <Form.Item
        className="mb-2"
        // validateStatus={!commentMessage.message.isValid && commentMessage.message.message && "error"}
      >
        <Input.TextArea
          name="message"
          autoSize={{ minRows: 1, maxRows: 2 }}
          placeholder="Isi komentar disini..."
        />
      </Form.Item>
      <Form.Item className="mb-1">
        <Button type="dark">Kirim</Button>
      </Form.Item>
    </Form>
  );

  return (
    <>
      <Comment
        className="comment-modif"
        avatar={<Avatar src={image} alt={username} />}
        author={body === MESSAGE ? author : body === REPLY && <></>}
        content={body === MESSAGE ? contentMessage : body === REPLY && contentReply}
      >
        {children}
      </Comment>
    </>
  );
};

export default CommentContainer;
